import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-folder-add",
  templateUrl: "./med-icon-folder-add.component.html",
})
export class MedIconFolderAddComponent extends SvgMixinComponent {}
